import { WorkOrderBase } from './base-classes/work-order-base'

// Let's create a new instance of the base, to get separate filter for each work order view
// Imported modules are singletons, so we can't just import the same base modules because filter values will be overwritten
const workOrderBase = new WorkOrderBase()

// Set state
workOrderBase.state.all.defaultFilter = {
  startDate: null,
  endDate: null,
  status: null,
  statuses: [],
  ownerOrHelperInitials: null,
  projectCode: null,
  objectName: null,
  customerName: null,
  workOrderOwnerInitials: null,
  workOrderHelperInitials: null,
  invoiceNote: null,
  internalNote: null,
  orderByColumn: 'verificationDate',
  orderByDescending: false,
  onlySharable: true, // Only sharable
  onlyNonInvoiced: false
}

const mutations = workOrderBase.mutations()

mutations.resetFilter = (state) => {
  state.all.currentPage = 1
  state.all.filter = Object.assign({}, state.all.defaultFilter)
}

export const workOrdersShare = {
  namespaced: true,
  state: workOrderBase.state,
  actions: workOrderBase.actions(),
  mutations: workOrderBase.mutations(),
  getters: workOrderBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/work-order-share.module.js